
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"196","height":"72","viewBox":"0 0 196 72","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42.1296 24V48H49.0653V24H42.1296ZM67.8749 32.572L50.5247 24V48L57.4604 44.5716V34.2853L67.8749 39.428L78.2666 34.2853V44.5716L85.2251 48V24L67.8749 32.572ZM86.9423 24H117.524V30.8569H93.878V32.5711H109.52L106.154 39.428H93.878V48H86.9423V24ZM129.562 36.0005L119.17 41.1431V47.9991L136.52 39.427L153.87 47.9991V41.1422L143.456 35.9995L153.87 30.8569V24L136.52 32.572L119.17 24V30.8569L129.562 36.0005Z","fill":"#16171F"}})])
          )
        }
      }
    